import {AdminUserAlert, DynamicBox, DynamicDialog, PageTitle, SelectText} from "../../_components";
import React, {useEffect, useMemo, useState} from "react";
import * as yup from "yup";
import {Formik, Form as FormikForm, FieldArray, Field} from "formik";
import {Alert, Button, ListGroup, Stack, Form} from "react-bootstrap";
import {useAuth, useDarkMode} from "../../../context";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useGetJson, useInfiniteScroll, usePostJson} from "../../../hooks";
import {endpoints} from "../../../utils2";
import {GoBackConfig} from "../_components/GoBackConfig";
import {ProgressSteps} from "../_components/ProgressSteps";
import {ABBreadcrumbs} from "../_components/ABBreadcrumbs";
import {WhiteCard} from "../_components/WhiteCard";
import announcementSettingDark from "../icons/announcement_setting_dark.svg"
import announcementSettingLight from "../icons/announcement_setting_light.svg"

export function AddEditAdvPlayback() {
    const {uid, vid} = useParams()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (vid === "new" && location.state == null) {
            navigate(`/device/${uid}`)
        }
    }, [location])

    if (location.state) {
        return <AddEditAdvPlaybackInt/>
    }
    return null
}

function AddEditAdvPlaybackInt() {
    const {userId, authToken} = useAuth()
    const {uid, did, vid} = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const currentStep = location.state.currentStep

    const edit = vid !== "new"

    const [ev, loadingEvent, errorEvent, clearErrorEvent] = useGetJson(vid === "new" ? null : endpoints.event.get(vid), authToken?.jwt)
    const event = ev?.data

    const [submitFormAdd, _, loadingAdd, errorAdd, clearErrorAdd] = usePostJson(endpoints.event.add(did), authToken?.jwt)

    const [submitFormEdit, _2, loadingEdit, errorEdit, clearErrorEdit] = usePostJson(endpoints.event.edit(vid), authToken?.jwt)

    const intervals = [
        {value: 1, name: "1 minute", disable: false},
        {value: 5, name: "5 minutes", disable: false},
        {value: 15, name: "15 minutes", disable: false},
        {value: 30, name: "30 minutes", disable: false},
        {value: 60, name: "60 minutes", disable: false},
        {value: 120, name: "120 minutes", disable: false},
    ]

    const validationSchema = yup.object().shape({
        announcements: yup.array(),
        announcement_interval: yup.number()
            .when("announcements", {
                is: (announcements) => announcements && announcements.length > 0,
                then: (schema) => schema.required("Interval is required")
                    .oneOf(
                        intervals.map((i) => i.value),
                        "Invalid interval"
                    ),
                otherwise: (schema) => schema.notRequired(),
            }),
        announcement_count: yup.number()
            .when("announcements", {
                is: (announcements) => announcements && announcements.length > 0,
                then: (schema) => schema.required("Number is required").min(1, "Must be at least 1"),
                otherwise: (schema) => schema.notRequired(),
            }),
    })

    const initialValues = {
        announcement_interval: location.state?.announcement_interval || event?.announcement_interval || 15,
        announcement_count: location.state?.announcement_count || event?.announcement_count || 1,
        announcements: location.state?.announcements || event?.announcements || [],
    }

    function handleOnSubmit(values, action) {
        const payload = {
            ...location.state, name: location.state?.name || event?.name, currentStep: currentStep + 1,
            announcements: values.announcements, announcement_interval: values.announcement_interval, announcement_count: values.announcement_count
        }

        if (currentStep === location.state.steps.length - 1 && !edit) {
            submitFormAdd(payload, jsonTime => {
                action.setSubmitting(false)
                navigate(location.state.steps[0])
            })
        } else if (edit) {
            submitFormEdit(payload, json => {
                action.setSubmitting(false)
                navigate(`/device/${uid}/${did}/config`)
            })
        } else {
            navigate(location.state.steps[currentStep + 1], {state: {...location.state, ...payload}})
        }
    }

    // if (edit && loadingEvent) {
    //     return <div>Loading...</div>;
    // }
    //
    const submitButton = (edit || currentStep === (location.state.steps.length - 1)) ? "Save" : "Next"

    function getAnnouncementSelected(list = []) {
        return Array.from({length: list.length}, (_, i) => i + 1);
    }

    return <Stack>
        <AdminUserAlert/>
        <Alert variant="danger" show={errorEvent} dismissible onClose={clearErrorEvent}>{errorEvent}</Alert>
        <Alert variant="danger" show={errorAdd} dismissible onClose={clearErrorAdd}>{errorAdd}</Alert>
        <Alert variant="danger" show={errorEdit} dismissible onClose={clearErrorEdit}>{errorEdit}</Alert>


        <ABBreadcrumbs breadcrumbList={[
            {name: "Your devices", shortName: "Devices", to: `/device/${uid}`},
            {name: "Configure Device", shortName: "Configure", to: `/device/${uid}/${did}/config`},
            {name: "Announcement"}]}
        />

        <PageTitle title="Set Announcement">{edit ? `Edit ${event?.name}` : `Add optionally`}.</PageTitle>

        {edit && loadingEvent && <div>Loading...</div>}

        <Alert variant="warning" className="py-1"> <i className="bi bi-exclamation-triangle me-2 fs-5"/>Plugging in a USB drive will immediately erase all existing data.
            Please back up any important files before attaching it.</Alert>
        <Formik validationSchema={validationSchema} onSubmit={handleOnSubmit} initialValues={initialValues} enableReinitialize={true}>
            {({isSubmitting, resetForm, values}) => (
                <FormikForm>

                    <ProgressSteps steps={location.state.steps.slice(1)} currentStep={currentStep}
                                   state={{
                                       ...location.state,
                                       name: location.state?.name || event?.name,
                                       announcements: values.announcements,
                                       announcement_interval: values.announcement_interval,
                                       announcement_count: values.announcement_count
                                   }} edit={edit}/>

                    <WhiteCard>
                        <FieldArray name="announcements" component={LinkedAnnouncements}/>
                    </WhiteCard>

                    <WhiteCard>
                        <SelectText name="announcement_interval" label="Play announcement interval" disabled={values.announcements.length === 0}>
                            {intervals.map((item, index) => (
                                <option key={index} value={item.value} disabled={item.disable}>{item.name}</option>
                            ))}
                        </SelectText>

                        <Field name="announcement_count">
                            {({field, meta, form}) => <Form.Group controlId="countId" className="">
                                <Form.Label column="" className="text-capitalize text-body-secondary">Number of announcements</Form.Label>
                                <Form.Select aria-label="Select sample" {...field} disabled={values.announcements.length === 0}>
                                    <option value="">-- select an option --</option>
                                    {getAnnouncementSelected(form.values.announcements).map((item, index) => (
                                        <option key={index} value={item}>{item}</option>
                                    ))}
                                </Form.Select>
                                <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                                <Form.Text muted>Number of random announcements to play in the interval.</Form.Text>
                            </Form.Group>}
                        </Field>
                    </WhiteCard>

                    <ChartDescription/>

                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        <GoBackConfig state={{
                            ...location.state,
                            name: location.state?.name || event?.name,
                            announcements: values.announcements,
                            announcement_interval: values.announcement_interval,
                            announcement_count: values.announcement_count
                        }} edit={edit}/>
                        <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>{submitButton}</Button>
                    </Stack>

                </FormikForm>
            )}
        </Formik>
    </Stack>
}

function LinkedAnnouncements({push, remove, form}) {
    const {uid} = useParams()
    const {authToken} = useAuth()

    const [show, setShow] = useState(false)
    const [filter, setFilter] = useState("")
    const [pageIndex, setPageIndex] = useState(0)

    const pageSize = 10

    const [anCount, loadingAnCount, errorAnCount, clearErrorAnCount, setAnnCount] = useGetJson(endpoints.announcement.count(uid), authToken?.jwt)
    const count = anCount?.data || 0

    const [anList, loadingList, errorAnList, clearErrorAnList] = useGetJson(endpoints.announcement.list(uid), authToken?.jwt)
    const list = anList?.data || []

    const loading = loadingAnCount || loadingList

    const lastElementRef = useInfiniteScroll(loading, list.length, count, pageSize, setPageIndex)

    const tempList = useMemo(() => list.filter(item => !form.values.announcements.find(item2 => item2.id === item.id)), [list, form.values.announcements])
    const renderList = useMemo(() => tempList.filter(item => item.filename.toLowerCase().includes(filter.toLowerCase())), [filter, tempList])
    const selectedItems = useMemo(() => form.values.announcements.sort((a, b) => a.filename.localeCompare(b.filename)), [form.values.announcements])

    const isInvalid = typeof form.errors.announcements === "string"


    return (
        <>
            <Alert variant="danger" show={errorAnList} dismissible onClose={clearErrorAnList}>{errorAnList}</Alert>
            <Alert variant="danger" show={errorAnCount} dismissible onClose={clearErrorAnCount}>{errorAnCount}</Alert>

            <DynamicBox label="Link announcements" isInvalid={isInvalid} feedback={form.errors.announcements} button="Announcement"
                        onClick={() => setShow(true)}>
                {selectedItems.map((item, idx) => (
                    <Button key={idx} className="mb-2" onClick={() => remove(idx)}>{item.filename} <i
                        className="bi bi-x-lg"/></Button>
                ))}
            </DynamicBox>
            <DynamicDialog title="Select Announcement" show={show} onHide={() => setShow(false)} filter={filter} setFilter={setFilter}>
                <div>Loaded {list.length - selectedItems.length} of {count - selectedItems.length}</div>
                {renderList && renderList.length > 0 ?
                    renderList.map((item, index) => (
                        <ListGroup.Item key={item.id} eventKey={item.id} ref={renderList.length === index + 1 ? lastElementRef : null}>
                            <Button variant="primary" onClick={() => push(list.find(c => c.id === item.id))} className="mb-2">{item.filename}</Button>
                        </ListGroup.Item>
                    ))
                    :
                    <span className="text-center">No announcement found.</span>
                }
            </DynamicDialog>
        </>
    )
}

function ChartDescription() {
    const {darkMode} = useDarkMode()
    if (darkMode) {
        return <img src={announcementSettingLight} alt="Announcement setting"/>
    } else {
        return <img src={announcementSettingDark} alt="Announcement setting"/>
    }
}
